import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import NavbarDropdown from './NavbarDropdown';
import { helpRoutes } from 'routes/topNav';
import { setConfig } from 'reducers/configReducer';

const NavbarTopDropDownMenus = () => {
  const dispatch = useDispatch();
  const { navbarCollapsed, showBurgerMenu } = useSelector(
    state => state.config
  );

  const handleDropdownItemClick = (e, route) => {
    if (navbarCollapsed) {
      dispatch(setConfig({ key: 'navbarCollapsed', value: !navbarCollapsed }));
    }
    if (showBurgerMenu) {
      dispatch(setConfig({ key: 'showBurgerMenu', value: !showBurgerMenu }));
    }
    e.preventDefault();
    if (route.name === 'About') {
      dispatch(setConfig({ key: 'showSplash', value: true }));
    }
    if (route.name === 'Getting started') {
      dispatch(setConfig({ key: 'showGettingStarted', value: true }));
    }
  };
  return (
    <>
      <NavbarDropdown title="help">
        {helpRoutes.children.map(route => (
          <Dropdown.Item
            key={route.name}
            as={Link}
            className={route.active ? 'link-600' : 'text-500'}
            to={route.to}
            onClick={e => handleDropdownItemClick(e, route)}
          >
            {route.name}
          </Dropdown.Item>
        ))}
      </NavbarDropdown>
    </>
  );
};

export default NavbarTopDropDownMenus;
